var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationDot = function SvgLocationDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 6.4c0-2.21-1.79-4-4-4s-4 1.79-4 4c0 .505.228 1.215.663 2.067.422.83.997 1.705 1.585 2.513a37 37 0 0 0 1.612 2.047l.14.166q.066-.08.14-.165a35 35 0 0 0 1.613-2.048c.587-.808 1.16-1.683 1.585-2.513.435-.852.662-1.562.662-2.067m.8 0c0 2.22-3.017 5.948-4.267 7.397-.328.38-.533.603-.533.603s-.205-.223-.532-.603C6.218 12.348 3.2 8.62 3.2 6.4a4.801 4.801 0 0 1 9.6 0m-6 0a1.2 1.2 0 1 0 2.4 0 1.2 1.2 0 0 0-2.4 0m1.2 2a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
  })));
};
export default SvgLocationDot;